import { combineReducers } from 'redux';

import auth, { IAuthStoreState } from 'store/auth/reducer';
import global, { IGlobalStoreState } from 'store/global/reducer';
import mpi, { IMpiStoreState } from 'store/mpi/reducer';
import repairs, { IRepairsStoreState } from 'store/repairs/reducer';
import repairRequest, {
  IRepairRequestStoreState,
} from 'store/repairRequest/reducer';

const rootReducer = combineReducers({
  auth,
  global,
  repairRequest,
  mpi,
  repairs,
});

export type AnyStoreState =
  | IAuthStoreState
  | IGlobalStoreState
  | IRepairRequestStoreState
  | IRepairsStoreState
  | IMpiStoreState;

export type RootStoreState = ReturnType<typeof rootReducer>;

export default rootReducer;
